import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICONS } from '../../../../_helpers/icons.constants';

@Component({
    selector: 'status-and-action-renderer',
    templateUrl: './status-and-action-renderer.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class StatusAndActionRendererComponent implements ICellRendererAngularComp {
    public text: string = '';
    public ICONS = ICONS;
    public isBullet: boolean = false;


    public description: string;
    public isMandatory: boolean = false;
    public isIcon: boolean = true;
    public classValue: string;


    public statusText: string = '';
    public statusValue: string = '';
    public actionText: string = '';

    private readonly statusConfig = [
        { id: 1, type: 'primary' },
        { id: 2, type: 'success' },
        { id: 3, type: 'pending' },
        { id: 4, type: 'incomplete' },
        { id: 5, type: 'not-enabled' }
    ];

    private params: any;
    public data: any;

    initilize(params: any): void {
        this.params = params;
        this.data = params.getValue();
        if (this.data) {
            this.text = this.statusConfig.find(item => item.id === this.data.statusType)?.type ?? '';
            this.actionText = this.data.actionText ?? '';
            // this.isIcon = params.colDef?.headerComponentParams?.isIcon;
            // this.isMandatory = params.data?.isMandatory;
            // this.description = this.data.description ?? '';
            // this.classValue = params.colDef?.headerComponentParams?.class;
            // this.isBullet = params?.colDef?.headerComponentParams?.isBullet
        }

    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

    onActionClick(event): void {
        this.params?.onActionClick?.(this.params);
    }
}
